import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { VehicleModel } from './../../vehicle/models/vehicle.model';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel, Permission } from '../../shared/config';
import { PersonModel } from '../../person/models/person.model';
import { VehicleService } from '../../vehicle/models/vehicle.service';


@Component({
  selector: 'wego-snail-trail-vehicle-popup',
  template: require('../views/snail-trail-vehicle-popup.component.html'),
  providers: [VehicleService]
})

export class SnailTrailVehiclePopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  vehicleList: VehicleModel[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('vehicleModal') public vehicleModal: any;

  constructor(private vehicleService: VehicleService
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) { }

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["licenceTag", 'ownerName', 'brand', 'type', 'vehicleClass', 'color'];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetVehicleList();
    this.vehicleModal.show();
  }

  public hide(): void {
    this.vehicleModal.hide();
  }

  private GetVehicleList() {
    this.isLoading = true;
    this.vehicleService.GetVehicleList(this.DataListModel, null, null, null, true,false,false,false,Permission.PR_SANIL_TRAIL_REPORT)
      .subscribe(
      res => {
        this.vehicleList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private select(vehicle: VehicleModel): void {
    this.isLoading = true;
    this.onSuccessSelect.emit({ VehicleMasterHashID: vehicle.vehicleMasterHashId, LicenceTage: vehicle.licenceTag });
    this.isLoading = false;
    this.hide();
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetVehicleList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetVehicleList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetVehicleList();
  };
  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetVehicleList();
  }
  private OnSuccessSelect() {
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/snail-trail/components/snail-trail-vehicle-popup.component.ts